import { FETCH_FIREBASE_DATA_REQUEST, FETCH_FIREBASE_DATA_SUCCESS, FETCH_FIREBASE_DATA_FAILURE } from './FirebaseTypes'
const initialState = {
    loading: false,
    data: {},
    error: ''
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_FIREBASE_DATA_REQUEST:
            return {
                ...state,
                loading: true
            }
        case FETCH_FIREBASE_DATA_SUCCESS:
            return {
                loading: false,
                data: action.payload
            }
        case FETCH_FIREBASE_DATA_FAILURE:
            return {
                loading: false,
                error: action.payload
            }

        default:
            return state;
    }
}
export default reducer;